export default {
  'profile': 'Profile',
  'name': 'Name',
  'refresh': 'Refresh',
  'bill': 'Bill',
  'history': 'History',
  'planing': 'Planning',
  'newRecord': 'New record',
  'categories': 'Categories',
  'billInCur': 'Account in the currency',
  'exRate': 'Exchange rate',
  'currency': 'Currency',
  'course': 'Course',
  'date': 'Date',
  'recHistory': 'History of records',
  'noRec': 'No records yet',
  'addRec': 'Add record',
  'prev': 'Back',
  'next': 'Next',
  'amount': 'Amount',
  'type': 'Type',
  'open': 'Open',
  'costsByCat': 'Costs by category',
  'income': 'Income',
  'outcome': 'Outcome',
  'more': 'See more',
  'smthGoneWrong': "Something gone wrong",
  'addNewRecord': 'Add new record',
  'stayed': 'Left',
  'limited': 'Limit exceeded',
  'description': 'Description',
  'noCategory': 'No categories yet. ',
  'addNewCategory': 'Add new category',
  'from': 'from',
  'logout': 'Logout',
  'chooseCategory': 'Choose category',
  'create': 'Create',
  'typeAmount': 'Type amount',
  'typeDesc': 'Type description',
  'valueMin': 'The value must be at least',
  'succesRec': 'Record succesful have been created!',
  'notEnoughMoney': 'Not enough money in the account!',
  'limit': 'Limit',
  'typeName': 'Type name',
  'succesCat': "Category succesful have been created!",
  'edit': 'Edit',
  'succesCatUpdate': 'Category succesful have been updated!',
  'detail': "Records details",
  'register': 'Register',
  'login': 'Login'
}
